import axios from './axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export function useGetLivewireEvents() {
  return useAxios({
    url: '/api/v1/livewire_events',
    method: 'GET',
  });
}

export function notUsed() {
  // TODO: eslint stop blaming about prefer default exports when there is only
  // one function.
}

export const recordEvent = eventData => {
  const csrfToken = document.querySelector("[name='csrf-token']").content;
  fetch('/statistic_events/create.json', {
    method: 'POST',
    headers: {
      'X-CSRF-Token': csrfToken,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ statistics_data: eventData }),
  });
};
